<div class="instructions-container">
	@if (instructionListTitle()) {
		<h3 class="instructions-title">{{ instructionListTitle() | translate }}</h3>
	}
	<ul class="instructions-list">
		@for (instruction of instructionList(); track instruction) {
			<li>{{ instruction | translate }}</li>
		}
	</ul>
</div>
